import { Component, OnInit, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'
import { DatePipe } from '@angular/common';
import { CommonService } from '../services/common.service';
import { TimeFormatPipe } from '../pipes/time-format.pipe';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-appointment',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.css'],
    standalone: false
})
export class AppointmentComponent implements OnInit {
  page = 1;
  pageSize = 10;

  list_length = 0;
  items_filter: any[] = [];
  patients: any[] = [];
  appointments: any[] = [];
  types: any[] = [];

  doctors: any[] = [];
  staffs: any[] = [];
  services: any[] = [];
  slots: any[] = [];
  doctor_slots: any[] = [];
  packages: any[] = [];
  packages_list: any[] = [];

  reasons: any[] = ['NONE',
    'Cancelled by Patient',
    'Cancelled by Doctor',
    'DNA',
    'Departed'
  ];

  rooms: any[] = [
    { 'room_001': 'Tratment Room 1' },
    { 'room_002': 'Tratment Room 2' },
    { 'room_003': 'Tratment Room 3' },
    { 'room_004': 'Tratment Room 4' },
    { 'adult_gym': 'Adults Gym' },
    { 'swim_pool': 'Swimming Pool' },
    { 'paeds_gym': 'Paeds Gym' },
    { 'overbooked': 'Overbooked Room' },
    { 'home_visit': 'Home visiting' },
    { 'home_visit_ob': 'Home visiting (OB)' }
  ];

  token: any;
  role: any;
  name: any;

  appointment_type: any = '';

  Swal = 'sweetalert2'
  textName: any = '';
  private searchDebounceTimer: any;

  // Method to check if an appointment matches the search term
  appointmentMatchesSearch(appointment: any): boolean {
    if (!this.textName || this.textName.trim() === '') {
      return false;
    }

    const searchTerm = this.textName.toLowerCase().trim();
    const firstName = appointment?.patient?.first_name?.toLowerCase() || '';
    const lastName = appointment?.patient?.last_name?.toLowerCase() || '';
    const fullName = `${firstName} ${lastName}`;
    const phone = appointment?.patient?.phone?.toString() || '';
    const phone2 = appointment?.patient?.phone2?.toString() || '';
    const patientNumber = (appointment?.patient?.patient_number || appointment?.patient?.number || '').toString().toLowerCase();

    return fullName.includes(searchTerm) ||
           firstName.includes(searchTerm) ||
           lastName.includes(searchTerm) ||
           phone.includes(searchTerm) ||
           phone2.includes(searchTerm) ||
           patientNumber.includes(searchTerm);
  }

  // Method to check if a cell contains a matching appointment
  cellHasMatch(date: any, start: any, end: any): boolean {
    if (!this.textName || this.textName.trim() === '') {
      return false;
    }

    const appointmentsInCell = this.checkItem(date, start, end);
    return appointmentsInCell.some(appointment => this.appointmentMatchesSearch(appointment));
  }

  onSearchChange() {
    clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => this.applySearchFilter(), 400);
  }

  clearSearch() {
    this.textName = '';
    clearTimeout(this.searchDebounceTimer);
    this.applySearchFilter();
  }

  private applySearchFilter() {
    this.filter_config.searchQueries = this.buildSearchQueries(this.textName);
    this.getItems();
  }

  /**
   * Build /appointments/filter queries from the search box:
   * - patient number: patient_number,like,{term}
   * - mobile: phone,phone2,like,{term}
   * - name: first_name,last_name,like,{term}
   */
  private buildSearchQueries(term: string): string[] {
    const value = (term || '').trim();
    if (!value) return [];

    const phoneCandidate = value.replace(/[\s+\-()]/g, '');

    // Mobile (digits only)
    if (/^\d{3,}$/.test(phoneCandidate) && !/[a-zA-Z]/.test(value)) {
      return [`phone,phone2,like,${phoneCandidate}`];
    }

    // Patient number (e.g. PL000018, P-123)
    if (/^(pl|p)[-_]?\w+/i.test(value) || (/[a-zA-Z]/.test(value) && /\d/.test(value) && /^[A-Za-z0-9\-]+$/.test(value))) {
      return [`patient_number,like,${value}`];
    }

    // Name (first and/or last)
    return [`first_name,last_name,like,${value}`];
  }

  cancel_reason: any = 'NONE';
  item = {
    date: ''
  }

  appointment = {
    date: '',
    doctor_id: null,
    recommended_by: null,
    patient_id: null,
    service_name: null,
    service_price: 0,
    final_price: 0,
    period: 30,
    service_id: null,
    active: false,
    room: null,
    is_package: false,
    has_pacakge: false,
    package_id: null,
    patient_package_id: null
  }

  package = {
    name: null,
    no_sessions: 0,
    full_price: 0
  };

  user_id: any;

  schedual_id: any;
  appointment_id: any;

  saving: boolean = false;
  filter_config: any;

  start_date: any;
  end_date: any;

  periodRangeLabel = '';

  constructor(public utility: UtilitiesService, private modalService: NgbModal, public api: ApiService, private route: ActivatedRoute, private router: Router, public datepipe: DatePipe, public common: CommonService, private cdr: ChangeDetectorRef, private appRef: ApplicationRef) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.role = localStorage.getItem('role');
    this.user_id = localStorage.getItem('id');
    this.name = localStorage.getItem('username');
    this.generateDateList();
    this.filter_config = {
      itemsPerPage: 5000,
      currentPage: 1,
      totalItems: 0,
      sort: null,
      sort_order: 'asc',
      pageSizeOptions: [5, 10, 25, 100],
      searchQueries: [] as string[]
    };

    this.setDateRangeQueries();
  }

  private setDateRangeQueries() {
    this.filter_config.queries = `date,ge,${this.start_date}`;
    this.filter_config.queries_1 = `date,le,${this.end_date}`;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;
      let doctor = params['doctor'] != null ? params['doctor'] : null;
      let patient = params['patient'] != null ? params['patient'] : null;
      let role = localStorage.getItem('role');

      this.getItems(doctor, patient);
      // if (role === 'doctor') {
      //   let objects = localStorage.getItem('doctors');

      //   if (objects) {
      //     let doctors: any[] = JSON.parse(objects);
      //     let doctor = doctors.find(i => i.user_id === this.user_id);

      //     this.getItems(doctor.id, patient);
      //   }
      // }
      // else
      //   this.getItems(doctor, patient);
    });
  }

  open(content: any, to?: any) {
    if (to === 'contentAppointment') {
      this.resetAppointmentForm();
      this.getPatients();

      let now = new Date();
      now.setMinutes(0, 0, 0);
      this.appointment.date = now.toISOString().slice(0, 16);
      this.refreshPeriodRange();
    }

    this.modalService.open(content);
  }

  onPeriodInput(event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    this.appointment.period = value;
    this.refreshPeriodRange(value);
  }

  refreshPeriodRange(minutesValue?: any): void {
    const minutes = Number(minutesValue ?? this.appointment?.period);
    const start = this.parseAppointmentDate();
    if (!start || !minutes || minutes <= 0) {
      this.periodRangeLabel = '';
      this.cdr.detectChanges();
      this.appRef.tick();
      return;
    }
    const end = new Date(start.getTime() + minutes * 60 * 1000);
    this.periodRangeLabel = `${this.formatClock(start)} to ${this.formatClock(end)}`;
    this.cdr.detectChanges();
    this.appRef.tick();
  }

  private parseAppointmentDate(): Date | null {
    if (!this.appointment?.date) {
      return null;
    }
    const parsed = new Date(this.appointment.date);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  private formatClock(date: Date): string {
    return this.datepipe.transform(date, 'h:mm a') || '';
  }

  getItems(doctor?: any, patient?: any) {
    // logged in doctor, or if admin then all... 
    this.utility.loading = true;
    const sub = this.api.get('appointments/filter', this.token, { params: this.getHttpParams() }).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.appointments = objects.appointments;

        if (doctor)
          this.appointments = this.appointments.filter(i => i.appointment.doctor_id === doctor);

        if (patient)
          this.appointments = this.appointments.filter(i => i.appointment.patient_id === patient);

        this.items_filter = this.appointments;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  /* generating time table*/
  currentDay: Date = new Date();
  dateList: Date[] = [];
  timeList: any[] = [];
  startTime = 9; // 9 am
  //endTime = 21; // 9 pm
  endTime = 24; // 12 am
  slotDuration = 60; // 60 minutes

  generateDateList() {
    // Find the nearest past Saturday
    const currentDayOfWeek = this.currentDay.getDay();
    const daysSinceSaturday = (currentDayOfWeek + 1) % 7; // Saturday is 6, so +1 % 7 will give the days since Saturday
    const startDate = new Date(this.currentDay);
    startDate.setDate(this.currentDay.getDate() - daysSinceSaturday);
    
    this.start_date = startDate.toISOString().slice(0, 10);

    this.dateList = [];
    for (let i = 0; i < 6; i++) {
      const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i);
      this.dateList.push(date);
    }

    // Add endDate as the last date in the dateList
    const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 7);
    this.end_date = endDate.toISOString().slice(0, 10);

    this.timeList = [];
    for (let hour = this.startTime; hour <= this.endTime; hour++) {
      for (let minute = 0; minute < 60; minute += this.slotDuration) {
        const formattedHour = hour.toString().padStart(2, '0');
        const formattedMinute = minute.toString().padStart(2, '0');
        this.timeList.push(`${formattedHour}:${formattedMinute}`);
      }
    }
  }

  goToPrevious() {
    this.currentDay.setDate(this.currentDay.getDate() - 6);
    this.generateDateList();
    this.setDateRangeQueries();
    this.getItems();
  }

  goToNext() {
    this.currentDay.setDate(this.currentDay.getDate() + 6);
    this.generateDateList();
    this.setDateRangeQueries();
    this.getItems();
  }
  /** Time table end  */

  _checkItem(date: any, star: any, end: any) {
    let select_date = this.datepipe.transform(date, 'yyyy-MM-dd');

    return this.appointments.filter(i => {
      const appointmentDate = this.datepipe.transform(i.appointment.date, 'yyyy-MM-dd');
      const appointmentStart = this.datepipe.transform(i.appointment.date, 'HH:mm');
      const appointmentEnd = this.datepipe.transform(i.appointment.end_date, 'HH:mm');

      return appointmentDate === select_date && appointmentStart !== null && appointmentStart >= star && appointmentEnd != null && appointmentEnd <= end;
    });
  }

  checkItem(date: any, start: any, end: any) {
    const select_date = this.datepipe.transform(date, 'yyyy-MM-dd');

    return this.appointments.filter(i => {
      const appointmentDate = this.datepipe.transform(i.appointment.date, 'yyyy-MM-dd');
      const appointmentStart = this.datepipe.transform(i.appointment.date, 'yyyy-MM-dd HH:mm');
      const appointmentEnd = this.datepipe.transform(i.appointment.end_date, 'yyyy-MM-dd HH:mm');

      // Convert start and end times of the slot to full date-time strings for comparison
      const slotStart = this.datepipe.transform(new Date(`${select_date} ${start}`), 'yyyy-MM-dd HH:mm');
      const slotEnd = this.datepipe.transform(new Date(`${select_date} ${end}`), 'yyyy-MM-dd HH:mm');

      // Check if any of the transformed dates are null
      if (!appointmentDate || !appointmentStart || !appointmentEnd || !slotStart || !slotEnd) {
        return false;
      }

      // Check for overlap between the appointment and the time slot
      return (
        appointmentDate === select_date &&
        appointmentStart !== null && appointmentStart < slotEnd &&
        appointmentEnd != null && appointmentEnd > slotStart
      );
    });
  }

  filterFunction(items: any[]) {
    if (this.textName == null) {
      this.list_length = items.length;
      return items;
    }
    else {
      let _items = items.filter(i => i.patient.first_name.toLowerCase().indexOf(this.textName.toLowerCase()) >= 0 ||
        i.patient.last_name.toLowerCase().indexOf(this.textName.toLowerCase()) >= 0 ||
        i.patient.phone && i.patient.phone.toString() === this.textName.toLowerCase() ||
        i.doctor.name.toLowerCase().indexOf(this.textName.toLowerCase()) >= 0);

      this.list_length = _items.length;
      return _items;
    }
  }

  onDelete(item: any) {
    Swal.fire({
      title: 'Do you want to delete this appointment?',
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.delete('appointments/' + item.id, this.token).subscribe(
          async data => {
            this.getItems();
            Swal.fire({
              title: 'Success!',
              text: 'Deleted Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );
      }
    })
  }

  approve(id: any) {
    Swal.fire({
      title: 'Appintment paied and Patient came?',
      showCancelButton: true,
      icon: 'success',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.update(`appointments/update_status/${id}/COMPLETED/NONE`, {}, this.token).subscribe(
          async data => {
            this.getItems();
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.modalService.dismissAll(); });
      }
    })
  }

  reject(id: any) {
    Swal.fire({
      title: 'This appointment will be cancelled',
      showCancelButton: true,
      icon: 'warning',
      confirmButtonText: 'Ok',
    }).then((result) => {
      if (result.isConfirmed) {
        let status = 'PENDING';
        let reason = 'NONE';

        if (this.cancel_reason === 'NONE') {
          status = 'CANCELLED';
          reason = 'NONE';
        }
        if (this.cancel_reason === 'Cancelled by Patient') {
          status = 'CANCELLED';
          reason = 'CANCLED_BY_PATIENT';
        }
        if (this.cancel_reason === 'Cancelled by Doctor') {
          status = 'CANCELLED';
          reason = 'CANCLED_BY_DOCTOR';
        }
        if (this.cancel_reason === 'DNA') {
          status = 'MISSED';
          reason = 'DNA';
        }
        if (this.cancel_reason === 'Departed') {
          status = 'MISSED';
          reason = 'DEPARTED';
        }

        const sub = this.api.update(`appointments/update_status/${id}/${status}/${reason}`, {}, this.token).subscribe(
          async data => {
            this.getItems();
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.modalService.dismissAll(); });
      }
    })
  }

  is_hidden(item: any) {
    if (this.utility.isAdmin())
      return false;

    if (item.appointment.is_happened)
      return true;

    return false
  }

  onAppointmentStatusChange() {
    if (this.appointment_type)
      this.appointments = this.items_filter.filter(i => i.appointment.status === this.appointment_type);
    else
      this.appointments = this.items_filter;
  }

  get weekRangeLabel(): string {
    if (!this.dateList.length) return '';
    const first = this.datepipe.transform(this.dateList[0], 'MMM d');
    const last = this.datepipe.transform(this.dateList[this.dateList.length - 1], 'MMM d');
    return `${first} - ${last}`;
  }

  getStatusCount(status: string): number {
    return this.appointments.filter(i => i?.appointment?.status === status).length;
  }

  goToDetails(appointment: any) {
    localStorage.removeItem('appointment');
    localStorage.setItem('appointment', JSON.stringify(appointment));

    this.router.navigate(['view_details']);
  }

  /** ************************ */
  async getPatients() {
    this.saving = true;
    const sub = this.api.get('patients/', this.token).subscribe(
      async data => {

        let objects: any = {}
        objects = data;

        this.patients = objects;

        this.patients.forEach((patient) => {
          patient.name = patient.first_name + ' ' + patient.last_name;
        })
      },
      async error => { }
    );

    sub.add(() => { this.getDoctors(); });
  }

  getDoctors() {
    // const sub = this.api.get('employees/role/doctor', this.token).subscribe(
    //   async data => {
    //     let objects: any = {}
    //     objects = data;

    //     this.doctors = objects;

    //     localStorage.setItem('doctors', JSON.stringify(this.doctors));
    //   },
    //   async error => { }
    // );

    // sub.add(() => { this.getStaffs(); });

    let doctors = localStorage.getItem('doctors');

    if (doctors) {
      this.doctors = JSON.parse(doctors);
      this.getStaffs();
    }

    // const sub = this.api.get('employees/role/doctor', this.token).subscribe(
    //   async data => {
    //     let objects: any = {}
    //     objects = data;
    //     this.doctors = objects;
    //   },
    //   async error => { }
    // );
    // sub.add(() => { this.getServices(); });
  }

  getStaffs() {
    const sub = this.api.get('employees/active', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.staffs = objects;

        this.staffs.filter(i => i.name != 'Amal');
      },
      async error => { }
    );
    sub.add(() => { this.getServices(); });
  }

  getServices() {
    const sub = this.api.get('services/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.services = objects;
      },
      async error => { }
    );
    sub.add(() => { this.getPackages(); });
  }

  async getPackages() {
    const sub = this.api.get('packages/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.packages = objects;
      },
      async error => { }
    );

    sub.add(() => { this.saving = false; });
  }

  dateSelection(slots: any[]) {
    let select_date = this.datepipe.transform(this.appointment.date, 'yyyy-MM-dd');
    return slots.filter(i => this.datepipe.transform(i.date_time, 'yyyy-MM-dd') === select_date);
  }

  getPrice() {
    if (this.appointment.service_id != null) {
      //this.saving = true;
      let service = this.services.find(i => i.id === this.appointment.service_id);
      // this is wrong
      let packag_ = this.packages.find(i => i.service_id === this.appointment.service_id);

      this.appointment.service_name = service.name;
      this.appointment.service_price = service ? service.price : 0;
      this.appointment.final_price = service ? service.price : 0;

      if (service) this.packages_list = this.packages.filter(i => i.service_id === service.id);

      // this may be checked inside getPatientPackgeService
      if (packag_)
        this.appointment.is_package = true;
      else
        this.appointment.is_package = false;

      this.getPatientPackgeService(this.appointment.patient_id, service.id);
    }
  }

  onChangePackage() {
    if (this.appointment.package_id != null) {
      let package_ = this.packages.find(i => i.id === this.appointment.package_id);

      this.package.no_sessions = package_.no_sessions;
      this.package.full_price = package_.full_price;
      this.package.name = package_.name;
      this.appointment.final_price = package_.full_price;
      this.appointment.service_price = package_.full_price;
    }
  }

  onChangePatient(event: any) {
    const value = event.target.value;
    const patient = this.patients.find(i => i.name === value);
    if (!patient) return;
    this.appointment.patient_id = patient.id;
  }

  /** check patient if has package on this Service */
  getPatientPackgeService(id: any, service_id: any) {
    this.saving = true;
    const sub = this.api.get('package_patients/patient/' + id + '/service/' + service_id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        let _package: any = objects;

        if (_package) {
          //this.appointment.is_package = true;
          this.appointment.has_pacakge = true;
          this.appointment.package_id = _package.package_id;
          this.appointment.patient_package_id = _package.id;
        }
        else {
          //this.appointment.is_package = false;
          this.appointment.has_pacakge = false;
        }
      });

    sub.add(() => { this.saving = false; });
  }

  createAppointment(content: any) {
    let minutes = new Date(this.appointment.date).getMinutes();
    let hours = new Date(this.appointment.date).getHours();

    if (this.appointment.date == null || this.appointment.date == '' || this.appointment.date == '0000-00-00 00:00:00' || Date.parse(this.appointment.date) == 0) {
      Swal.fire({
        title: 'Warning!',
        text: 'Please enter a vaild appointment date!',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
    }
    //else if (hours < 9 || hours > 20) {
    else if (hours < 9 || hours > 24) {
      Swal.fire({
        title: 'Warning!',
        text: 'No appontments before 9AM or after 8PM!',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
    }
    else {
      // if ((minutes + +this.appointment.period) > 60) {
      //   Swal.fire({
      //     title: 'Warning!',
      //     text: 'Please check the appointment Period is not exeeding the slot!',
      //     icon: 'warning',
      //     confirmButtonText: 'Ok'
      //   });
      // }
      // else {
      if (!this.appointment.is_package || this.appointment.has_pacakge) {
        const body = {
          date: this.appointment.date,
          period: this.appointment.period,
          service_name: this.appointment.service_name,
          service_price: this.appointment.service_price,
          final_price: this.appointment.final_price,
          service_id: this.appointment.service_id,
          patient_id: this.appointment.patient_id,
          doctor_id: this.appointment.doctor_id,
          recommended_by: this.appointment.recommended_by,
          room: this.appointment.room,
          is_package: false,
          has_pacakge: this.appointment.has_pacakge,
          package_id: this.appointment.package_id,
          patient_package_id: this.appointment.patient_package_id
        }

        this.create_new_appointment(body);
      }
      else if (this.appointment.is_package || !this.appointment.has_pacakge)
        this.modalService.open(content);
      //}
    }
  }

  // [TODO] Create with package
  createAppointment_with_package() {
    const body = {
      date: this.appointment.date,
      period: this.appointment.period,
      service_name: this.appointment.service_name,
      service_price: this.appointment.service_price,
      final_price: this.appointment.final_price,
      service_id: this.appointment.service_id,
      patient_id: this.appointment.patient_id,
      doctor_id: this.appointment.doctor_id,
      recommended_by: this.appointment.recommended_by,
      room: this.appointment.room,
      is_package: this.appointment.package_id ? true : false,
      has_pacakge: this.appointment.package_id ? true : false,
      package_id: this.appointment.package_id,
      patient_package_id: this.appointment.patient_package_id
    }

    this.create_new_appointment(body);
  }

  create_new_appointment(body: any) {
    this.saving = true;
    const sub = this.api.post("appointments/", body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'Appointment Added Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        });
      },
      async error => {
        if (error.status == 405)
          Swal.fire({
            title: 'Warning!',
            text: 'This Room is booked on this time period, please Check different Time slot!',
            icon: 'warning',
            confirmButtonText: 'Ok'
          });
        else
          Swal.fire({
            title: 'Error!',
            text: 'Error making the appointment :(',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
      }
    );

    sub.add(() => {
      this.resetAppointmentForm();

      this.getItems();
      this.modalService.dismissAll();
      this.saving = false;
    });
  }

  resetAppointmentForm() {
    this.appointment = {
      date: '',
      doctor_id: null,
      recommended_by: null,
      patient_id: null,
      service_name: null,
      service_price: 0,
      final_price: 0,
      period: 30,
      service_id: null,
      active: false,
      room: null,
      is_package: false,
      has_pacakge: false,
      package_id: null,
      patient_package_id: null
    };
    this.refreshPeriodRange();

    this.package = {
      name: null,
      no_sessions: 0,
      full_price: 0
    };
  }

  get_room(room: any) {
    const object = this.rooms.find(item => item.hasOwnProperty(room));
    return object ? object[room] : null;
  }

  getHttpParams() {
    let params = new HttpParams();
    params = params.append('page', this.filter_config.currentPage.toString());
    params = params.append('per_page', this.filter_config.itemsPerPage.toString());
    if (this.filter_config.sort) {
      params = params.append('sort', this.filter_config.sort);
      params = params.append('sort_order', this.filter_config.sort_order);
    }
    if (this.filter_config.queries) {
      params = params.append('queries', this.filter_config.queries);
    }
    if (this.filter_config.queries_1) {
      params = params.append('queries', this.filter_config.queries_1);
    }
    for (const query of this.filter_config.searchQueries || []) {
      params = params.append('queries', query);
    }
    return params;
  }
}
